// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardCountry_cardContainer__1kdCs","img":"CardCountry_img__3kO6A","titulosContainer":"CardCountry_titulosContainer__hdsTt"};